/*eslint-disable no-script-url*/
import React, { Component } from 'react';
import * as Common from '../components/Common';

class BranchRegionPop extends Component {
  constructor(props) {
    super(props);

    this.state = {
      style: null,
      sido: '',
      sigungu: '',
      dong: '',
      sidos: null,
      sigungus: null,
      dongs: null,
    };
  }

  componentDidMount() {
    var _sido = this.props.sido;
    var _sigungu = this.props.sigungu;
    var _dong = this.props.dong;

    this.setState({ 
      style: Common.getCenterPosStyle(this.layer),
      sido: _sido,
      sigungu: _sigungu,
      dong: _dong
    });

    this._getSidos();

    if(_sido) {
      this._getSigungus(_sido);
    }

    if(_sigungu) {
      this._getDongs(_sido, _sigungu);
    }
  }

  /**
   * 시도 조회
   */
  _getSidos = async () => {
    const result = await Common.callApi('/hp/sidos', 'post', {onesBranchType: 'TSC'});
    if(result.resultCode === 'success') {
      this.setState({ sidos: result.resultDataList });
    }
  }

  /**
   * 시군구 조회
   */
  _getSigungus = async (sido) => {
    const result = await Common.callApi('/hp/sigungus', 'post', {onesBranchType: 'TSC', addressSidoname: sido});
    if(result.resultCode === 'success') {
      this.setState({ sigungus: result.resultDataList });
    }
  };

  /**
   * 동 조회
   */
  _getDongs = async (sido, sigungu) => {
    const result = await Common.callApi('/hp/dongs', 'post', {onesBranchType: 'TSC', addressSidoname: sido, addressSigunguname: sigungu});
    if(result.resultCode === 'success') {
      this.setState({ dongs: result.resultDataList });
    }
  }

  /**
   * 지역변경 이벤트
   */
  _onChangeRegion = (type, region, e) => {
    this.setState({ [type]: region });
    if(type === 'sido') {
      // 시도를 선택시 시군구&동을 전체로 셋팅
      this.setState({
        sigungu: '',
        dong: '',
        sigungus: null,
        dongs: null
      });
      if(region) this._getSigungus(region);
    } else if(type === 'sigungu') {
      // 시군구 선택시 동을 전체로 셋팅
      this.setState({
        dong: '',
        dongs: null
      });
      // 선택한 시군구가 전체 아닌 경우 해당 시군구의 동 조회
      if(region) this._getDongs(this.state.sido, region);
    }
  }

  /**
   * 지역 리스트 그리기
   */
  _renderRegion = (type, param) => {
    var _list = this.state[type.concat('s')];
    return (
      <ul className="list scroll-style">
        <li key={type} className={!this.state[type] ? 'active' : ''}><a href={null} onClick={this._onChangeRegion.bind(this, type, '')}><span>전체</span></a></li>
        {_list && _list.length > 0 ? _list.map((entity, index) => <li key={type.concat(index)} className={this.state[type] === entity[param] ? 'active' : ''}><a href={null} onClick={this._onChangeRegion.bind(this, type, entity[param])}><span>{entity[param]}</span></a></li>) : ''}
      </ul>
    )
  }

  render() {
    return (
      <div className="layer-pop" id="locaseach-pop" style={this.state.style} ref={ref => this.layer = ref}>	
	      <div className="bg" data-type="region" onClick={this.props.onClick} ref={ref => this.layerBg = ref}></div>
        <div className="loca-seach-pop">
          <div className="loca-sel">
            {this._renderRegion('sido', 'addressSidoname')}
            {this._renderRegion('sigungu', 'addressSigunguname')}
            {this._renderRegion('dong', 'addressDongname')}
          </div>
          <a href={null} className="check-btn" data-type="region" data-sido={this.state.sido} data-sigungu={this.state.sigungu} data-dong={this.state.dong} onClick={this.props.onClick}>확인</a>
        </div>
      </div>
    )
  }
}

export default BranchRegionPop;